module.exports = __webpack_public_path__ + "static/media/logout.3b74f0c1.svg";